/**
 * Class names tagged onto `renderMarkdown` output, kept in their own
 * side-effect-free module. Consumers that only need the string — notably the
 * globally-mounted `<ImageLightbox/>` in RootLayout — import from here so they
 * don't eagerly pull marked + DOMPurify (and the renderer setup in
 * `markdownRenderer.ts`) into every page's bundle.
 */

// Applied to external <a> tags so the chat stylesheets can render the ↗
// affordance via ::after. Referenced instead of hard-coding the string.
export const EXTERNAL_LINK_CLASS = 'ai-md-extlink';

// Applied to rendered markdown images so a global delegate (`<ImageLightbox/>`)
// can open them full-screen on click — the image counterpart to the
// `.md-table-expand` table lightbox. The class only exists on renderMarkdown
// output, so the listener never matches avatars, icons, or next/image.
export const MARKDOWN_IMAGE_CLASS = 'ai-md-image';
